export default __webpack_public_path__ + "static/media/EE-VLSI.4eba28e0.pdf";